import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { EnvironmentSpaceAccess } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  onError?: () => void
  onSuccess?: (response: EnvironmentSpaceAccess) => void
  children?: (response: EnvironmentSpaceAccess) => ReactElement
}

const GetEnvironmentSpaceAccessRequest = ({
  id,
  onError,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/agents/${id}/space_access`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetEnvironmentSpaceAccessRequest
